import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fetchDailyBlotterColumnsEpic, fetchDailyBlotterQuotesEpic } from './dailyBlotterEpics';

export const dailyBlotterEpics = () =>
  withAppCrashIfException('dailyBlotter', combineEpics(fetchDailyBlotterQuotesEpic(), fetchDailyBlotterColumnsEpic()));
